import "./style.scss";
import TrainingFormatsCards from "./TrainingFormatsCards/Desk/TrainingFormatsCards";
import TrainingFormatsCardsMob from "./TrainingFormatsCards/Mob/TrainingFormatsCardsMob";
import TrainingFormatsDescription from "./TrainingFormatsDescription/TrainingFormatsDescription";

const TrainingFormats = () => {
  return (
    <section className="training-formats container section-margin-top">
      <TrainingFormatsDescription />
      {window.innerWidth >= 768 ? <TrainingFormatsCards /> : <TrainingFormatsCardsMob />}
    </section>
  );
};
export default TrainingFormats;
